<template>
  <!-- <v-app>
    <v-app-bar
      app
      color="dark"
      dark
    >
    <v-toolbar-title>Graph Layout Labelling</v-toolbar-title>
    <v-spacer></v-spacer>
    <v-tooltip bottom>
    <template v-slot:activator="{ on, attrs }">
    <v-btn
            class="ma-2"
            large
            fab
            color="dark"
            v-bind="attrs"
            v-on="on"
            >
            <v-icon large>mdi-google-analytics</v-icon>
    </v-btn>
    </template>
    <span style="font-size:200%">Statistics</span>
    </v-tooltip>
    </v-app-bar> -->

    <!-- <v-main> -->
        <router-view :key="$route.fullPath"></router-view>
    <!-- </v-main>
  </v-app> -->
</template>

<script>

export default {
  name: 'App',

  data: () => ({
    //
  }),
};
</script>
